import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VForm,
    {
      ref: "appointment-patient-form",
      class: _vm.isMobile ? "px-2" : "px-6",
      attrs: {
        "data-qa": "appointment_patient_form",
        disabled: _vm.isSavingProfile,
      },
    },
    [
      _c(VTextField, {
        ref: "appointment-patient-field-surname",
        attrs: {
          outlined: "",
          label: _vm.$t("Фамилия", _vm.options),
          "data-qa": "appointment_patient_form_surname_input",
          disabled: _vm.disabledFields.surname || _vm.isSavingProfile,
          value: _vm.patient.surname,
          rules: _vm.fioValidationRules.surname,
        },
        on: {
          input: function ($event) {
            return _vm.updatePatient({ field: "surname", value: $event })
          },
        },
      }),
      _vm._v(" "),
      _c(VTextField, {
        ref: "appointment-patient-field-name",
        attrs: {
          outlined: "",
          label: _vm.$t("Имя", _vm.options),
          "data-qa": "appointment_patient_form_name_input",
          disabled: _vm.disabledFields.name || _vm.isSavingProfile,
          value: _vm.patient.name,
          rules: _vm.fioValidationRules.name,
        },
        on: {
          input: function ($event) {
            return _vm.updatePatient({ field: "name", value: $event })
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(VTextField, {
            ref: "appointment-patient-field-patronymic",
            staticClass: "mb-1",
            attrs: {
              outlined: "",
              label: _vm.$t("Отчество", _vm.options),
              "data-qa": "appointment_patient_form_patronymic_input",
              "hide-details": "auto",
              value: _vm.patient.patronymic,
              rules: _vm.patient.hasPatronymic
                ? _vm.fioValidationRules.patronymic
                : [],
              disabled:
                !_vm.patient.hasPatronymic ||
                _vm.disabledFields.patronymic ||
                _vm.isSavingProfile,
            },
            on: {
              input: function ($event) {
                return _vm.updatePatient({ field: "patronymic", value: $event })
              },
            },
            scopedSlots: _vm._u([
              {
                key: "message",
                fn: function ({ message }) {
                  return [
                    _c("div", { staticClass: "pb-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(message, _vm.options)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-body-2 mb-4 pl-3 d-inline-block",
              class:
                _vm.disabledFields.patronymic || _vm.isSavingProfile
                  ? "disabled--text"
                  : "primary--text cursor-pointer",
              attrs: {
                "data-qa": "appointment_patient_form_switch_patronymic",
              },
              on: {
                click: function ($event) {
                  _vm.disabledFields.patronymic || _vm.isSavingProfile
                    ? undefined
                    : _vm.updatePatient({
                        field: "hasPatronymic",
                        value: !_vm.patient.hasPatronymic,
                      })
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    !_vm.patient.hasPatronymic
                      ? _vm.$t("Есть отчество", _vm.options)
                      : _vm.$t("Нет отчества", _vm.options)
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(VTextField, {
        directives: [
          {
            name: "mask",
            rawName: "v-mask",
            value: _vm.birthDayMask,
            expression: "birthDayMask",
          },
        ],
        ref: "appointment-patient-field-birthday",
        attrs: {
          outlined: "",
          label: _vm.$t("Дата рождения", _vm.options),
          "data-qa": "appointment_patient_form_birthday_input",
          placeholder: _vm.$t("ДД.ММ.ГГГГ", _vm.options),
          disabled: _vm.disabledFields.birthDay || _vm.isSavingProfile,
          rules: _vm.birthDayValidationRules,
          value: _vm.patient.birthDay,
          "validate-on-blur":
            _vm.patient.birthDay.length < _vm.birthDayMask.length,
          hint: _vm.birthDayValidationHint,
          "persistent-hint": "",
        },
        on: {
          input: function ($event) {
            return _vm.updatePatient({ field: "birthDay", value: $event })
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleSave.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-6" },
        [
          _c(
            VRadioGroup,
            {
              ref: "appointment-patient-field-gender",
              staticClass: "mt-0 pt-0",
              attrs: {
                row: "",
                "hide-details": "",
                value: _vm.patient.gender,
                disabled: _vm.disabledFields.gender || _vm.isSavingProfile,
                rules: _vm.genderValidationRules,
                "data-qa": "appointment_patient_form_radios",
              },
              on: {
                change: function ($event) {
                  return _vm.updatePatient({ field: "gender", value: $event })
                },
              },
            },
            [
              _c("div", { staticClass: "text-caption w-100 mb-3" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("Пол", _vm.options)) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(VRadio, {
                staticClass: "ml-2",
                attrs: {
                  value: "M",
                  "data-qa": "appointment_patient_form_radio_m",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "text-body-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Мужской", _vm.options)) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c(VRadio, {
                staticClass: "ml-10",
                attrs: {
                  value: "F",
                  "data-qa": "appointment_patient_form_radio_f",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "text-body-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Женский", _vm.options)) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VBtn,
        {
          staticClass: "w-100 mt-2",
          attrs: {
            color: "primary",
            depressed: "",
            disabled: _vm.isSavingProfile,
            loading: _vm.isSavingProfile,
          },
          on: { click: _vm.handleSave },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("Сохранить", _vm.options)) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }